import routes from '@utils/constants/routes'
import { rootActions } from '@store/slices'
import { COOKIE_KEYS, getCookie, setCookie } from '../index'
import store from '@app-store/store'

export const getBundles = path => {
    const bundles = ['General']
    switch (true) {
        case path.includes(routes.trade_hub.rfq._):
            bundles.push('TradeHub')
            break
        case path.includes(routes.organizer._):
        case path.includes(routes.analytics._):
            bundles.push('Dashboard')
            bundles.push('Event')
            bundles.push('TradeHub')
            break
        case path.includes(routes.trade_hub._):
            bundles.push('TradeHub')
            bundles.push('Dashboard')
            break
        case path.includes(routes.meeting_request._):
        case path.includes(routes.meetings._):
            bundles.push('Meeting')
            bundles.push('EventAgenda')
            bundles.push('TradeHub')
            bundles.push('Dashboard')
            break
        case path.includes(routes.matching._):
            bundles.push('Matching')
            bundles.push('TradeHub')
            bundles.push('Meeting')
            bundles.push('Dashboard')
            break
        case path.includes(routes.settings._):
            bundles.push('Event')
            bundles.push('Settings')
            bundles.push('Meeting')
            bundles.push('EventAgenda')
            bundles.push('TradeHub')
            bundles.push('Dashboard')
            bundles.push('Integration')
            bundles.push('Matching')
            break
        case path.includes(routes.directory._):
            bundles.push('TradeHub')
            bundles.push('Settings')
            bundles.push('Meeting')
            bundles.push('Dashboard')
            bundles.push('Matching')
            break
        case path.includes(routes.subscription._):
            bundles.push('TradeHub')
            bundles.push('Dashboard')
            break
        case path.includes(routes.alarms._):
            bundles.push('Meeting')
            bundles.push('TradeHub')
            bundles.push('Dashboard')
            break
        case path.includes(routes.crm._):
            bundles.push('Settings')
            bundles.push('Dashboard')
            bundles.push('TradeHub')
            bundles.push('Integration')
            break
        case path.includes(routes.database_import._):
            bundles.push('Event')
            bundles.push('TradeHub')
            bundles.push('Settings')
            bundles.push('Dashboard')
            break
        case path.includes(routes.exhibitor._):
            bundles.push('TradeHub')
            bundles.push('Matching')
            bundles.push('Dashboard')
            break
    }
    return bundles
}

export const getExtraKeys = path => {
    const extraKeys = [
        'Company_Profile',
        'Open_Guide_Tour',
        'Open_Guide_Video',
        'Match',
        'Application_Demo',
        'Employees',
        'Save_And_Leave',
        'Skip',
        'Meeting Request',
        'Delete_Description',
        'MatchList_Name',
        'Give_MatchList_Group',
        'Match_List_Saved',
        'Match_List_Section',
        'Go_Match_List'
    ]
    switch (true) {
        case path.includes(routes.trade_hub.rfq._):
            break
    }
    return extraKeys
}

export const changeAppLanguage = language => {
    const eventId = getCookie(COOKIE_KEYS.ALA_EVENT)
    setCookie(COOKIE_KEYS.LANG, language)
    if (eventId) {
        store.dispatch(
            rootActions.localization.updateLanguage.onRequest({
                data: { language },
                sagaCB: {
                    onSuccess: res => {
                        location.reload()
                    }
                }
            })
        )
    } else {
        location.reload()
    }
}
